/**
 * O agente às vezes escreve o rótulo todo em caixa alta ("ALIMENTAÇÃO PARENTERAL"); na tela, ele vira frase, com as siglas
 * preservadas. Usado na aba de dados e nas sugestões do item clínico.
 */

const SIGLAS = new Set(['KATZ', 'NEAD', 'PAD', 'CID', 'HAS', 'DM', 'IW', 'CPF', 'CEP', 'UTI', 'SUS']);

export function emFrase(rotulo: string): string {
  if (rotulo !== rotulo.toUpperCase()) return rotulo;
  const frase = rotulo
    .toLowerCase()
    .split(' ')
    .map((p) => (SIGLAS.has(p.toUpperCase()) ? p.toUpperCase() : p))
    .join(' ');
  return frase.charAt(0).toUpperCase() + frase.slice(1);
}
